<template>
  <div class="app-main">
    <van-tabs line-width="22%">
      <van-tab title="手机号登录">
        <h4 class="land_title">登录账户</h4>
        <van-form ref="domform" @submit="onSubmit()">
          <div class="dispflex">
            <van-field :value="from.value" @click="showPicker = true" />
            <van-field v-model="from.username" name="手机号" show-error type="tel" placeholder="请填写手机号" :rules="fromrules.username" />
          </div>
          <van-field v-model="from.sms" center clearable :rules="fromrules.sms" placeholder="请输入短信验证码">
            <template #button>
                <countDown :username="from.username" :num='120' />
            </template>
          </van-field>
          <div style="margin: 16px;">
            <van-button id="Agent_Mobile_Login" round block type="info" class="butland" native-type="submit">登录</van-button>
            <div class="poster-land-tip">请不要在2分钟内频繁发送验证码</div>
          </div>
        </van-form>
      </van-tab>
      <van-tab title="工号登录">
        <h4 class="land_title">登录账户</h4>
        <van-form ref="domform" @submit="onlogin()">
          <van-field v-model="from.username1" name="手机号" show-error  placeholder="请输入您的工号" :rules="fromrules.username1" />
          <van-field v-model="from.agentPassword" type="password" center clearable :rules="fromrules.agentPassword" placeholder="请输入您的初始密码"></van-field>
          <div style="margin: 16px;">
            <van-button id="Agent_WorkCode_Login" round block type="info" class="butland" native-type="submit">登录</van-button>
          </div>
        </van-form>
      </van-tab>
    </van-tabs>

    <van-popup v-model="showPicker" round position="bottom">
      <van-picker show-toolbar :columns="columns" @cancel="showPicker = false" @confirm="onConfirm" />
    </van-popup>
  </div>
</template>

<script>
import countDown from './components/countdown'
import md5 from 'blueimp-md5'
import { agentUserLogin, agentUserEmployeeNoLogin } from '@/api/poster'

export default {
  name: 'PosterLand',
  components: {
    countDown
  },
  mixins: [],
  props: {},
  data() {
    return {
      from:{
        sms:'',
        username: '',
        username1: '',
        agentPassword: '',
        value: '+86'
      },
      fromrules:{
        username:[{ pattern:/^(?:(?:\+|00)86)?1\d{10}$/, trigger: 'onChange' }],
        sms: [{ required: true, message: '' }],
        username1: [{ required: true, trigger: 'onChange' }],
        agentPassword: [{ pattern:/^[a-zA-Z0-9]{8,30}$/, message: '密码不能是中文特殊字符,且至少8位以上' }]
      },
      showPicker: false,
      columns: ['+86', '+12', '+23', '+55', '+99', '+32', '+45', '+53'],
    }
  },
  computed: {},
  watch: {},
  created() {},
  async mounted() {},
  // 如果页面有keep-alive缓存功能，这个函数会触发
  activated() { },
  methods: {
    async onlogin () {
      try{
        let parmes = {
          empNo: this.from.username1,
          pwd: md5(this.from.agentPassword)
        }
        let res = await agentUserEmployeeNoLogin(parmes)
        if(res.isModifyPwd === '0'){
          this.$router.push({ path: '/poster-changepwd',query:{
              id: res.id,
              username: this.from.username1,
              token: res.token
            }
          })
        } else {
          if(res.code===0){
            this.$router.push({ path: '/perfect-information',query:{
              id:res.id,
              token:res.token
            } })
          }else if(res.code===1){
            this.$router.push({ path: '/poster-deal',query:{
              id:res.id,
              token:res.token
            } })
    
          }
        }
        localStorage.setItem("orderSn", JSON.stringify(res))
      } catch(e) {
        this.$notify({ type: 'danger', message: e.message })
      }
    },
    onSubmit() {
      let parmes = {
        mobilePhone: this.from.username,
        captcha: this.from.sms
      }
      agentUserLogin(parmes).then(res=>{
        if(res.code===0){
           this.$router.push({ path: '/perfect-information',query:{
             id:res.id,
             token:res.token
           } })
          localStorage.setItem("orderSn", JSON.stringify(res))
        }else if(res.code===1){
           this.$router.push({ path: '/poster-deal',query:{
             id:res.id,
             token:res.token
           } })
           localStorage.setItem("orderSn", JSON.stringify(res))
        }
      }).catch((e) => {
         this.$notify({ type: 'danger', message: e.message })
      })
    },
    onConfirm(value) {
      this.from.value = value;
      this.showPicker = false;
    },
  }
}
</script>
<style lang='scss' scoped>
.app-main {
  padding: 0 px2rem(33);
}
.land_title {
  margin-top: px2rem(140);
  font-size: px2rem(46);
  font-weight: 500;
  color: #000;
  line-height: px2rem(69);
}
.dispflex {
  display: flex;
  > div:nth-child(1) {
    > ::after {
      content: '';
      width: 0px;
      height: 0px;
      border-top: 6px solid #000;
      border-left: 6px solid transparent;
      border-right: 6px solid transparent;
      border-bottom: 6px solid transparent;
      position: absolute;
      top: 12px;
      right: 0;
    }
    width: 90px;
  }
  .van-cell::after {
    display: none;
  }
}
.sendverification{
  font-size: px2rem(34);
  color: #333;
  border: none;
}
.butland{
  height: px2rem(120);
  background: linear-gradient(to right, #FF6C61 , #DB0003);;
  border-radius:  px2rem(60);
  border-color: #EDEEF2;
}
.poster-land-tip{
  color: #888888;
  font-size: xvw(20);
  text-align: center;
  margin-top: xvw(30);
  letter-spacing: xvw(2);
}
</style>
